import { Cartesian3 } from "cesium";
import { computeBottomZCorrection } from "./solid-mesh-geometry";
// Pure math lives in solid-mesh-geometry.ts; this module holds only the
// mesh-mutating constraint pass.
/**
 * Enforces anchor constraints after a transform (rotate/scale).
 * Applies bottomZ correction for shapes with anchorType "top-start".
 * Call from Handler/Builder after SolidMesh.rotate() or .scale().
 * Synchronous: the correction's localDz is applied to localCenter directly
 * within the mesh's current local frame (the shift is small).
 * Never throws — logs a warning on failure.
 */
export function enforceAnchorConstraint(solidMesh) {
    try {
        const attrs = solidMesh.attributes;
        if (!attrs ||
            attrs.bottomZ === undefined ||
            attrs.anchorType !== "top-start") {
            return;
        }
        const dims = solidMesh.shapeConfig.dimensions;
        if (!dims)
            return;
        const scale = solidMesh.shapeConfig.scale;
        const renderedHeight = Math.abs(dims.z) * Math.abs(scale?.z ?? 1);
        const correction = computeBottomZCorrection(attrs, renderedHeight, solidMesh.shapeConfig.quaternion, solidMesh.getAnchorLocal());
        if (correction) {
            const localCenter = solidMesh.shapeConfig.localCenter;
            solidMesh.translate(new Cartesian3(localCenter.x, localCenter.y, localCenter.z + correction.localDz));
        }
    }
    catch (e) {
        console.warn("enforceAnchorConstraint failed:", e);
    }
}
//# sourceMappingURL=solid-mesh-helper.js.map